/** Контекст радио-группы UI-kit (provide/inject между UiKitRadioGroup и UiKitRadio). */
import type { ComputedRef, Ref } from 'vue'
import type { HuiColor, HuiSize } from './palette'

export interface RadioGroupContext {
  name: string
  color: ComputedRef<HuiColor>
  size: ComputedRef<HuiSize>
  disabled: ComputedRef<boolean>
  invalid: ComputedRef<boolean>
  selected: Ref<string | number | undefined>
  select: (value: string | number) => void
}

export const UI_KIT_RADIO_GROUP = Symbol('ui-kit-radio-group')
